import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/mass-payment',
    name: 'MassPaymentPage',
    component: () => import('@/modules/massPayment/views/MassPaymentPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
